import React, { memo } from 'react';
import { array, bool } from 'prop-types';
import classNames from 'classnames';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import Locale from '@active/react-utils/i18n/Locale';
import Responsive from '@active/react-utils/components/Responsive';
import getOrderLineFieldsConfig from '../config/orderLinefieldConfig';

const OrderLineTitle = ({
  orderLineFieldsConfig, isShowButtonCol,
  descriptionTitleId,
  amountTitleId, className,
}) => {
  const classes = classNames({
    'order-detail__content-orderLineTitle': true,
  }, className);
  const currentOrderLineFieldsConfig = orderLineFieldsConfig
  || getOrderLineFieldsConfig({ isShowButtonCol });
  const { labelColTitleSpanConfig, valueColTitleSpanConfig } = currentOrderLineFieldsConfig.orderLineTitleConfig;
  return <Grid container={false} colGap={0} rowGap={0} className={classes}>
    <GridItem {...labelColTitleSpanConfig} className="order-detail__content-title">
      { <Locale id={descriptionTitleId}/>}
    </GridItem>
    <GridItem {...valueColTitleSpanConfig} className="order-detail__content-subTitle">
      {<Locale id={amountTitleId}/>}
    </GridItem>
  </Grid>;
};

OrderLineTitle.propTypes = {
  OrderLineTitle: array,
  isOrderLineGroupsView: bool,
};

OrderLineTitle.defaultProps = {
  OrderLineTitle: [],
  isOrderLineGroupsView: false,
};

const OrderLineTitleContainer = (props) => {
  const { isShowButtonCol } = props;
  return <React.Fragment>
    <Responsive eqAbove="md">
      <OrderLineTitle {...props}/>
    </Responsive>
    <Responsive not eqAbove="md">
      {!isShowButtonCol && <OrderLineTitle {...props}/>}
    </Responsive>
  </React.Fragment>;
};

export default memo(OrderLineTitleContainer);
